import { LEVER_SWAP_CONFIG } from './swapConfig';
import { safeNormalize } from './swapUtils';

export function buildSushiSwapUrl({ tokenIn, tokenOut, amount, sender }) {
  const apiURL = new URL(`${LEVER_SWAP_CONFIG.SUSHI_SWAP_API_BASE}/${LEVER_SWAP_CONFIG.CHAIN_ID}`);
  apiURL.searchParams.set('tokenIn', tokenIn);
  apiURL.searchParams.set('tokenOut', tokenOut);
  apiURL.searchParams.set('amount', String(amount));
  apiURL.searchParams.set('maxSlippage', String(LEVER_SWAP_CONFIG.SLIPPAGE_FACTOR));
  apiURL.searchParams.set('sender', safeNormalize(sender));
  return apiURL;
}

export async function fetchSushiSwapData(params) {
  const url = buildSushiSwapUrl(params);
  const response = await fetch(url.toString());
  const data = await response.json();
  if (!response.ok || data?.status !== 'Success') {
    const error = new Error(`Sushi API failed: ${data?.status || response.status}`);
    error.details = data;
    error.url = url.toString();
    throw error;
  }
  return { url: url.toString(), data };
}
